"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationCompanyRegulatoryFields = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let LocalizationCompanyRegulatoryFields = class LocalizationCompanyRegulatoryFields {
    constructor(id, fieldKey, dataType, required, active, displayOrder, createAt, updatedAt, metaData) {
        this.id = id;
        this.fieldKey = fieldKey;
        this.dataType = dataType;
        this.required = required;
        this.active = active;
        this.displayOrder = displayOrder;
        this.createAt = createAt;
        this.updatedAt = updatedAt;
        this.metaData = metaData;
    }
};
exports.LocalizationCompanyRegulatoryFields = LocalizationCompanyRegulatoryFields;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], LocalizationCompanyRegulatoryFields.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "field_key", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], LocalizationCompanyRegulatoryFields.prototype, "fieldKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "data_type",
        type: "varchar",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], LocalizationCompanyRegulatoryFields.prototype, "dataType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "required", type: "boolean", nullable: false }),
    tslib_1.__metadata("design:type", Boolean)
], LocalizationCompanyRegulatoryFields.prototype, "required", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "active", type: "boolean", nullable: false }),
    tslib_1.__metadata("design:type", Boolean)
], LocalizationCompanyRegulatoryFields.prototype, "active", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "display_order", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], LocalizationCompanyRegulatoryFields.prototype, "displayOrder", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "create_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], LocalizationCompanyRegulatoryFields.prototype, "createAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], LocalizationCompanyRegulatoryFields.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meta_data", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Record !== "undefined" && Record) === "function" ? _f : Object)
], LocalizationCompanyRegulatoryFields.prototype, "metaData", void 0);
exports.LocalizationCompanyRegulatoryFields = LocalizationCompanyRegulatoryFields = tslib_1.__decorate([
    (0, typeorm_1.Entity)("localization_company_regulatory_fields"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, Boolean, Boolean, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object])
], LocalizationCompanyRegulatoryFields);
